import { handleActions, createActions } from 'redux-actions';
import { Map } from 'immutable';

export const { updateCommentHint } = createActions({
  updateCommentHint: result => result
});

const initState = Map({
  /** 评论红点 */
  commentHint: false
});

const notification = handleActions(
  {
    [updateCommentHint]: (state, action) => {
      return state.set('commentHint', action.payload);
    }
  },
  initState
);

export default notification;
